.popup {
  z-index: 1;
}

.menuList {
  width: 275px;
}
